/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Suspense } from "react";
import {BrowserRouter} from "react-router-dom";
import Footer from "./Components/common/Footer";
import Header from "./Components/common/Header";
import CustomRoutes from "./router/CustomRoutes";
import PerformanceMonitor from "./Components/common/PerformanceMonitor";
import { useTranslation } from "react-i18next";

// localStorage için güvenli helper fonksiyonları
const safeLocalStorage = {
  getItem: (key) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return localStorage.getItem(key);
      }
    } catch (error) {
      console.warn('localStorage getItem failed:', error);
    }
    return null;
  },

  setItem: (key, value) => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(key, value);
        return true;
      }
    } catch (error) {
      console.warn('localStorage setItem failed:', error);
    }
    return false;
  }
};

// Loading component for Suspense
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    fontSize: '18px'
  }}>
    <div>Yükleniyor...</div>
  </div>
);

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Sadece client tarafında çalıştır
    if (typeof window !== 'undefined') {
      // localStorage'dan kaydedilmiş dili al
      const savedLanguage = safeLocalStorage.getItem('selectedLanguage');
      if (savedLanguage) {
        i18n.changeLanguage(savedLanguage);
      } else {
        // Eğer kaydedilmiş dil yoksa tarayıcı dilini kontrol et
        const userLanguage = navigator.language || navigator.userLanguage;
        if (userLanguage.includes("tr")) {
          i18n.changeLanguage("tr");
          safeLocalStorage.setItem('selectedLanguage', 'tr');
        } else {
          i18n.changeLanguage("en");
          safeLocalStorage.setItem('selectedLanguage', 'en');
        }
      }
    }
  }, [i18n]);

  const changeLanguage = async (lng) => {
    try {
      await i18n.changeLanguage(lng);
      // Güvenli localStorage kullan
      safeLocalStorage.setItem('selectedLanguage', lng);
    } catch (error) {
      console.error('Language change failed:', error);
    }
  };

  return (
    <>
      <PerformanceMonitor />
      <BrowserRouter>
        <Header changeLanguage={changeLanguage} />
        <Suspense fallback={<LoadingSpinner />}>
          <CustomRoutes changeLanguage={changeLanguage} />
        </Suspense>
        <Footer changeLanguage={changeLanguage} />
      </BrowserRouter>
    </>
  );
}

export default App;
